module.exports = __webpack_public_path__ + "static/img/sec3-content-img04@w.7dd47b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hanssem/sec3-content-img04@w.jpg
// module id = 4So8
// module chunks = 0